var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-card-container" },
    [
      _vm.projectList.length
        ? _c(
            "el-row",
            { attrs: { gutter: 30 } },
            _vm._l(_vm.projectList, function (p) {
              return _c(
                "el-col",
                { key: p.id, attrs: { span: 4.5 } },
                [
                  _c(
                    "el-card",
                    {
                      key: p.id,
                      staticClass: "move",
                      attrs: {
                        "body-style": { padding: "0px", position: "static" },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "body",
                          on: {
                            click: function ($event) {
                              _vm.toProjectHandle(
                                p,
                                _vm.getProjectStatus(p.status).detailPage
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "el-row",
                            {
                              attrs: {
                                align: "middle",
                                justify: "center",
                                type: "flex",
                              },
                            },
                            [
                              _c("el-col", { attrs: { span: 20 } }, [
                                _c("span", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.removeHtmlTag(p.name))),
                                ]),
                              ]),
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "form-type",
                                    style: {
                                      backgroundColor: _vm.getType(p.type)
                                        .color,
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.getType(p.type).name))]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "status" }, [
                            _c("span", {
                              staticClass: "status-tag",
                              style: _vm.getStatusColorStyle(p.status),
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "status-name",
                                style: {
                                  color: _vm.getProjectStatus(p.status).color,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getProjectStatus(p.status).name)
                                ),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "card-time-div" }, [
                            _c("span", { staticClass: "card-time" }, [
                              _vm._v(
                                "创建时间：" +
                                  _vm._s(_vm._f("formatDate")(p.createTime))
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "card-time-div" }, [
                            _c("span", { staticClass: "card-time" }, [
                              _vm._v("创建人：" + _vm._s(p.userName)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "btns" },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                trigger: "click",
                                placement: "bottom-end",
                                width: "50",
                                "popper-class": "btns_more_popover",
                              },
                            },
                            [
                              _c("div", [
                                _vm.canEditProject(p)
                                  ? _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName: "v-permission",
                                            value: ["myProject_edit"],
                                            expression: "['myProject_edit']",
                                          },
                                        ],
                                        staticClass: "btns_more_item fs12",
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit(
                                              "editProject",
                                              p.formKey
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" 编辑问卷 ")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btns_more_item fs12 mb-10 mt-10",
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "openPreviewHandle",
                                          p.formKey
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 预览问卷 ")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btns_more_item fs12 mb-10 mt-10",
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "copyProject",
                                          p.formKey
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("复制问卷")]
                                ),
                                _vm.canShowProjectPermission(p)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "btns_more_item fs12",
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit(
                                              "addProjectAssistant",
                                              p.formKey
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" 项目权限 ")]
                                    )
                                  : _vm._e(),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "btns_more",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [_c("i", { staticClass: "el-icon-more" })]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm.projectList.length == 0
        ? _c(
            "div",
            [
              _c("el-empty", {
                attrs: { slot: "empty", description: "暂无数据" },
                slot: "empty",
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }